<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-introduction element-with-heading" id="introduction">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">INTRODUCTION</h1>
</div>
</div>
</div>
</div>
<div class="text" id="introduction-text">
<p class="first first-in-chapter first-full-width">This cookbook, created by <i>New York Times, USA TODAY</i> and National Bestselling Authors, is inspired by a collective effort from authors for the #ILIKEFREEBOOKS promotion and #TRIBEVIBE. It contains an interesting mix of cuisines from all over the world. Also, feel free to click on the books that are offered, it will take you straight to the download pages.</p>
<p class="subsq">Enjoy!</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width">Be sure to join our Kings of the Castle Ambassadors FB Group, and the Naleighna Kai Literary Cafe, as well as visit us online at <a class="content-external-link text-is-url" href="http://www.naleighnakai.com" target="_blank">www.naleighnakai.com</a>. Join the mailing list to receive updates when free book promos, new releases, discounted promotions, and NetGalley offerings are available.</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><a class="content-external-link" href="http://bit.ly/KOCAmbassadors" target="_blank"><span class="underline">Kings of the Castle Ambassadors</span></a></p>
<p class="subsq"><a class="content-external-link text-is-url" href="http://bit.ly/KOCAmbassadors" target="_blank">http://bit.ly/KOCAmbassadors</a></p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><a class="content-external-link" href="http://bit.ly/KOCFanPage" target="_blank"><span class="underline">Kings of the Castle Fan Page</span></a></p>
<p class="subsq"><a class="content-external-link text-is-url" href="http://bit.ly/KOCFanPage" target="_blank">http://bit.ly/KOCFanPage</a></p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><a class="content-external-link" href="http://bit.ly/NKLiteraryCafe" target="_blank"><span class="underline">NK Literary Cafe</span></a></p>
<p class="subsq"><a class="content-external-link text-is-url" href="http://bit.ly/NKLiteraryCafe" target="_blank">http://bit.ly/NKLiteraryCafe</a></p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width">Also, be sure to check out the Fit for a King Cookbook as well.</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/fit-for-a-king-cook-book-kindle.jpg"/>
</div>
</div>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><a class="content-external-link text-is-url" href="https://books2read.com/Fitforakingcookbook" target="_blank"><b>https://books2read.com/Fitforakingcookbook</b></a></p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><b>If you are an author who wishes to participate in cookbook offerings or any other promotion opportunities we have going on, email <a class="content-external-link text-is-url" href="mailto:naleighnakai@gmail.com">naleighnakai@gmail.com</a></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?47103b6f